<template>
  <div class="device-return">
    <div class="query-filter"  v-if="isFilter">
      <div class="params-form">
        <el-row :gutter="23">
          <el-col :span="8">
            <div class="item" v-if="isCoJv && showSubsidiary">
              <div class="label">{{ $t('device_return.zu_lin_fang') }}</div>
              <div class="value">
                <custom-select
                  url="OrganSelect"
                  :model="formSearch"
                  :params="{ childOrgType: 'CS' }"
                  v-model="formSearch.customerId"
                  :props="{ label: 'partnerName', value: 'partnerOrgId', map: { partnerName: 'orgName' } }"
                  :placeholder="$t('Common.com_please_select')"
                  @change="onPageChange({ page: 1 })"
                  filterable
                ></custom-select>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="item">
              <div class="label">{{ $t('Common.com_location') }}</div>
              <div class="value">
                <custom-select
                  filterable
                  :listener="formSearch.customerId"
                  url="MyDeviceLocationTagSelect"
                  :model="formSearch"
                  v-model="formSearch.locationId"
                  :params="{ customerId: isCoJv ? (showSubsidiary ? formSearch.customerId : '') : userInfo.rootOrgId }"
                  :props="{ label: 'locationName', value: 'locationId', map: { locationName: 'locationName'} }"
                  :placeholder="$t('Common.com_please_select')"
                  :dataFilter="dataFilter"
                  @getList="getTagsList"
                  @change="onPageChange({ page: 1 })"
                  theme="yellow"
                >
                </custom-select>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="item">
              <div class="label">{{ $t('Common.com_site') }}</div>
              <div class="value">
                <custom-select
                  :auto="false"
                  :listener="formSearch.locationId || null"
                  url="locationSiteList"
                  :model="formSearch"
                  v-model="formSearch.siteId"
                  :params="{ locationId: formSearch.locationId }"
                  :props="{ label: 'siteName', value: 'siteId', map: { siteName: 'siteName' } }"
                  :placeholder="$t('Common.com_please_select')"
                  @getList="getTagsList1"
                  :dataFilter="dataFilter1"
                  @change="onPageChange({ page: 1 })"
                >
                </custom-select>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="item">
              <div class="label">{{ $t('Common.com_model_no') }}</div>
              <div class="value">
                <custom-select
                  url="productCodeSelectList"
                  multiple
                  v-model="formSearch.productCode"
                  :props="{ label: 'productCode', value: 'productCode' }"
                  @change="onProductChange"
                  :placeholder="$t('Common.com_please_select')"
                  width="100%"
                  theme="yellow"
                ></custom-select>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="item">
              <div class="label">{{ $t('device_return.tui_zu_ri_qi') }}</div>
              <div class="value">
                <custom-date-picker
                  :clearable="false"
                  v-model="formSearch.returnDate"
                  @change="onTimeOutChange"
                  type="daterange"
                  style="width: 100%"
                  value-format="YYYY-MM-DD HH:mm:ss"
                  :picker-options="beforeToday"
                ></custom-date-picker>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="filter-values">
        <div class="label">{{ $t('Common.com_filter_item') }}</div>
        <div class="values">
          <el-tag
            key="1"
            v-if="formSearch.customerId"
            closable
            @close="
              formSearch.customerId = '';
              formSearch.orgName = '';
            "
          >
            {{ formSearch.orgName }}
          </el-tag>
          <el-tag
              v-if="tagId"
              closable
              @close="
                tagId='';
                formSearch.tagId = '';
                formSearch.tagName = '';
                onPageChange({ page: 1 });
              "
            >
              {{ formSearch.tagName }}
            </el-tag>
          <el-tag
            key="2"
            v-if="formSearch.locationId"
            closable
            @close="
              formSearch.locationId = '';
              formSearch.locationName = '';
            "
          >
            {{ formSearch.locationName }}
          </el-tag>
          <el-tag
            key="3"
            v-if="formSearch.siteId"
            closable
            @close="
              formSearch.siteId = '';
              formSearch.siteName = '';
            "
          >
            {{ formSearch.siteName }}
          </el-tag>
          <el-tag closable v-for="productTag in productTagList" :key="productTag.value" @close="onCloseTag(productTag.value, 'productTagList', 'productCode')">{{ productTag.label }}</el-tag>
          <el-tag
            key="4"
            v-if="formSearch.unbindStartTime"
            closable
            @close="
              formSearch.unbindStartTime = '';
              formSearch.unbindEndTime = '';
              formSearch.returnDate = [];
            "
          >
            {{ $momentLocal(formSearch.unbindStartTime, 'YYYY-MM-DD') }} - {{ $momentLocal(formSearch.unbindEndTime, 'YYYY-MM-DD') }}
          </el-tag>
          <span class="clear" @click="onClear">{{ $t('Common.com_clear') }}</span>
        </div>
      </div>
    </div>
    <div class="table-content">
      <div class="header">
        <div class="tab-box">
          <el-form :inline="true" @submit.native.prevent class="form-screen" style="display: flex">
            <el-form-item style="flex: 1; margin-bottom: 0">
              <span style="font-weight: bold; font-size: 17px; color: #202945">{{ $t('device_return.she_bei_lie_biao') }}</span>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="table-bd" v-if="tableList.length > 0">
        <div class="ubw">
          <device-widget v-for="item in tableList" :key="item.bodyNum" type="return" :item="item"></device-widget>
        </div>
      </div>
      <div class="table-bd" v-else>
        <div class="no-data">{{ $t('Common.com_no_data') }}</div>
      </div>
      <div class="page-footer">
        <custom-pagination :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange" radius></custom-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import deviceWidget from '@/components/deviceWidget';

export default {
  name: 'device_return',
  components: { deviceWidget },
  props: {
    isFilter: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      tagId: '',
      floorId: '',
      tags: [],
      tags1: [],
      productTagList: [], // 产品多选标签
      formSearch: {
        search: this.value,
        pageNum: 1,
        pageSize: 50,
        customerId: '',
        orgName: '',
        locationId: '',
        locationName: '',
        siteId: '',
        siteName: '',
        productCode: '',
        returnDate: [],
        unbindStartTime: '',
        unbindEndTime: '',
        tagName: '',
        tagId: '',
        showSubsidiary: '',
      },
      deviceCount: {},
      tableList: [],
      totalRows: 0
    };
  },
  mounted: function () {
    this.getTableList();
  },
  methods: {
    // 获取标签(项目)列表
    getTagsList(list) {
      const arr = [];
      list.forEach((item) => {
        const isHas = arr.find(t => t.tagId === item.tagId);
        if (!isHas && item.tagId && item.tagName) {
          arr.push({
            tagId: item.tagId,
            tagName: item.tagName
          });
        }
      });
      this.tags = arr;
    },
    // 获取标签(区域)列表
    getTagsList1(list) {
      const arr = [];
      list.forEach((item) => {
        const isHas = arr.find(t => t.floorId === item.floorId);
        if (!isHas && item.floorId && item.floorName) {
          arr.push({
            floorId: item.floorId,
            floorName: item.floorName
          });
        }
      });
      this.tags1 = arr;
    },
    // 点击(项目)标签
    onItemTag(tagId, tagName) {
      if (tagId === this.tagId) {
        this.tagId = '';
      } else {
        this.tagId = tagId;
        this.formSearch.tagId = tagId;
        this.formSearch.tagName = tagName;
        this.onPageChange({ page: 1 });
      }
    },
    // 点击(区域)标签
    onItemTag1(floorId) {
      if (floorId === this.floorId) {
        this.floorId = '';
      } else {
        this.floorId = floorId;
      }
    },
    // 过滤项目
    dataFilter: function (list) {
      if (!this.tagId) {
        return list;
      }
      return list.filter(t => t.tagId === this.tagId);
    },
    // 过滤区域
    dataFilter1: function (list) {
      if (!this.floorId) {
        return list;
      }
      return list.filter(t => t.floorId === this.floorId);
    },
    // 产品型号多选
    onProductChange(data) {
      if (!data || !data.length) {
        this.productTagList = [];
      } else {
        this.productTagList = data.map(item => ({
          label: item.productCode,
          value: item.productCode,
          ...item
        }));
      }
      this.onPageChange({ page: 1 });
    },
    // 退租日期区间
    onTimeOutChange(times) {
      if (!times || !times.length) {
        this.formSearch.unbindStartTime = '';
        this.formSearch.unbindEndTime = '';
      } else {
        this.formSearch.unbindStartTime = times[0];
        this.formSearch.unbindEndTime = times[1];
      }
      this.onPageChange({ page: 1 });
    },
    // 删除标签
    onCloseTag(value, tagList, key) {
      this[tagList] = this[tagList].filter(item => item.value !== value);
      this.formSearch[key] = this[tagList].map(item => item.value);
      this.onPageChange({ page: 1 });
    },
    // 清空标签
    onClear() {
      this.productTagList = [];
      this.formSearch.customerId = '';
      this.formSearch.orgName = '';
      this.formSearch.locationId = null;
      this.formSearch.locationName = '';
      this.formSearch.productCode = '';
      this.formSearch.tagId = '';
      this.formSearch.tagName = '';
      this.tagId = '';
      this.onPageChange({ page: 1 });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 获取数据
    getTableList() {
      this.formSearch.search = this.value;
      this.formSearch.showSubsidiary = this.showSubsidiary;
      this.$getJSON(apis.PortalHisDevicePage, this.formSearch).then(async (res) => {
        const deviceList = res.data.list || [];
        if (deviceList.length > 0) {
          const list = await this.formatAttachList(deviceList, 'productCodeId', 'dms.product.icon');
          this.tableList = list;
        } else {
          this.tableList = deviceList;
        }
        this.totalRows = res.data.total;
      });
    },
    // 跳转详情
    onJumpDetails(item) {
      this.jump('/other/device/accountDeviceDetail', {
        bodyNum: item.bodyNum,
        deviceId: item.deviceId
      });
    }
  }
};
</script>

<style lang="scss"></style>
